import { Text as AlphaText } from '@oneaudi/unified-web-alpha-components';

export default AlphaText;
